import { LoggedUser, invoiceStatusConfig } from 'entities';

import { LoadedPackage } from './types';

export function calculateAmountInvoiced({ invoices }: LoadedPackage): number {
  const consumedValue =
    invoices?.reduce(
      (acc, next) =>
        next.status === invoiceStatusConfig.canceled.code ? acc : acc + Number(next.value),
      0,
    ) ?? 0;

  return consumedValue;
}

export function calculateAmountLeftToInvoice(loadedPackage: LoadedPackage): number {
  const consumedValue = calculateAmountInvoiced(loadedPackage);

  return Number(loadedPackage.value) - consumedValue;
}

export function canCreateInvoice(loadedPackage: LoadedPackage, user: LoggedUser): boolean {
  if (!user.team.isInvoiceTeam) return false;

  const consumedValue = calculateAmountInvoiced(loadedPackage);

  return consumedValue < Number(loadedPackage.value);
}

export function isInvoiceValueOk(data: LoadedPackage, value: string): boolean {
  const availableAmount = calculateAmountLeftToInvoice(data);

  const selectedValueIsOk = !!value && Number(value) <= availableAmount;

  return selectedValueIsOk;
}
